import { PortableText } from '@portabletext/react';
import React from 'react';

export const TabDetails = ({ data, processStyles }) => (
  <div className="processes-description is-hover mb-3">
    <h3 className="h6 mb-3 text-white">{data.title}</h3>
    <div className={`text-white-75 divider ${processStyles.dividerClass}`}>
      <PortableText value={data.description} />
    </div>
  </div>
);
